import styled from 'styled-components'
import { vimovaTheme } from '../../theme/vimovaTheme'

export const HeroCardsRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 16px;

  @media print {
    display: flex !important;
    gap: 12px !important;
    margin-top: 16px !important;
  }
`

export const HeroCard = styled.div`
  flex: 1;
  background: ${vimovaTheme.colors.white};
  border: 1px solid ${vimovaTheme.colors.border};
  border-radius: ${vimovaTheme.borderRadius.signature};
  padding: 14px;

  @media print {
    flex: 1 !important;
    background: ${vimovaTheme.colors.white} !important;
    border: 1px solid ${vimovaTheme.colors.border} !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    padding: 14px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const HeroLabel = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.micro};
  color: ${vimovaTheme.colors.textMuted};

  @media print {
    font-size: ${vimovaTheme.fontSizes.micro} !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const HeroValue = styled.div<{ $color?: string }>`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.black};
  font-size: 28px;
  color: ${({ $color }) => $color || vimovaTheme.colors.primary};
  margin-top: 4px;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.black} !important;
    font-size: 28px !important;
    color: ${({ $color }) => $color || vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const HeroSmallValue = styled.div<{ $color?: string }>`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.black};
  font-size: 16px;
  color: ${({ $color }) => $color || vimovaTheme.colors.primary};
  margin-top: 4px;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.black} !important;
    font-size: 16px !important;
    color: ${({ $color }) => $color || vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const HeroSubtext = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 8px;
  color: ${vimovaTheme.colors.textLight};
  margin-top: 2px;

  @media print {
    font-size: 8px !important;
    color: ${vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MapPlaceholder = styled.div`
  background: ${vimovaTheme.colors.backgroundWarm};
  border: 1px solid ${vimovaTheme.colors.border};
  border-radius: ${vimovaTheme.borderRadius.signature};
  height: 160px;
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.small};
  color: ${vimovaTheme.colors.textMuted};

  @media print {
    background: ${vimovaTheme.colors.backgroundWarm} !important;
    border: 1px solid ${vimovaTheme.colors.border} !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    height: 160px !important;
    margin-top: 16px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const PermitCardsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 16px;

  @media print {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 12px !important;
    margin-top: 16px !important;
  }
`

export const PermitCard = styled.div<{ $statusColor: string }>`
  background: ${vimovaTheme.colors.white};
  border: 1px solid ${vimovaTheme.colors.border};
  border-radius: ${vimovaTheme.borderRadius.signature};
  padding: 0;
  overflow: hidden;
  position: relative;
  border-left: 4px solid ${({ $statusColor }) => $statusColor};

  @media print {
    background: ${vimovaTheme.colors.white} !important;
    border: 1px solid ${vimovaTheme.colors.border} !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    border-left: 4px solid ${({ $statusColor }) => $statusColor} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const PermitCardContent = styled.div`
  padding: 10px 14px;

  @media print {
    padding: 10px 14px !important;
  }
`

export const PermitBadgeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media print {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
  }
`

export const PermitBadge = styled.span<{ $color: string }>`
  display: inline-block;
  padding: 3px 12px;
  border-radius: 9px;
  background: ${({ $color }) => $color}26;
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: 7px;
  color: ${({ $color }) => $color};

  @media print {
    padding: 3px 12px !important;
    border-radius: 9px !important;
    background: ${({ $color }) => $color}26 !important;
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: 7px !important;
    color: ${({ $color }) => $color} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const PermitNumber = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: ${vimovaTheme.fontSizes.micro};
  color: ${vimovaTheme.colors.primary};
  margin-top: 10px;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: ${vimovaTheme.fontSizes.micro} !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const PermitAddress = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 8px;
  color: ${vimovaTheme.colors.text};
  margin-top: 2px;

  @media print {
    font-size: 8px !important;
    color: ${vimovaTheme.colors.text} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const PermitDescription = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 8px;
  color: ${vimovaTheme.colors.textLight};
  margin-top: 6px;
  line-height: 1.4;

  @media print {
    font-size: 8px !important;
    color: ${vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const PermitDivider = styled.div`
  height: 1px;
  background: ${vimovaTheme.colors.border};
  margin: 8px 0;

  @media print {
    height: 1px !important;
    background: ${vimovaTheme.colors.border} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const PermitFooterRow = styled.div`
  display: flex;
  gap: 16px;
  font-family: ${vimovaTheme.fonts.body};
  font-size: 7px;
  color: ${vimovaTheme.colors.textMuted};

  @media print {
    display: flex !important;
    gap: 16px !important;
    font-size: 7px !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const PermitIndexBadge = styled.div<{ $color: string }>`
  position: absolute;
  top: 10px;
  right: 14px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: ${({ $color }) => $color}26;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: ${vimovaTheme.fontSizes.micro};
  color: ${({ $color }) => $color};

  @media print {
    width: 24px !important;
    height: 24px !important;
    border-radius: 50% !important;
    background: ${({ $color }) => $color}26 !important;
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    color: ${({ $color }) => $color} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`
